import React, { useMemo } from 'react';
import Alert from '@mui/material/Alert';

import { PlaybookVariable } from 'src/services/api/playbooks/use-playbook-variables';
import { getVariablesFromMessage } from 'src/common/playbook-variables/playbook-variable-utils';

type Props = {
    message: string;
}

export default function PlaybookWarning({
    message,
}: Props) {
    const warning = useMemo(() => {
        const foundVars = getVariablesFromMessage(message);

        const isPropertyAddressUsed = foundVars.includes(PlaybookVariable.PropertyAddress);
        const isTourLinkUsed = foundVars.includes(PlaybookVariable.PropertyTourLink);
        const isApplicationLinkUsed = foundVars.includes(PlaybookVariable.PropertyApplicationLink);
        const isReviewLinkUsed = foundVars.includes(PlaybookVariable.ReviewLink);

        if (!(isPropertyAddressUsed || isTourLinkUsed || isApplicationLinkUsed || isReviewLinkUsed)) {
            return;
        }

        let _warning = 'To receive this message, the lead has to have a property assigned.';
        const propertyRequirements = [];

        if (isTourLinkUsed) {
            propertyRequirements.push('a tour link');
        }
        if (isApplicationLinkUsed) {
            propertyRequirements.push('an application link');
        }
        if (isReviewLinkUsed) {
            propertyRequirements.push('review links enabled');
        }

        if (propertyRequirements.length > 0) {
            const finalRequirement = propertyRequirements.pop();
            const requirements = propertyRequirements.length > 0 ?
                `${propertyRequirements.join(', ')} and ${finalRequirement}` :
                finalRequirement;
            _warning += ` Also, the associated property has to have ${requirements}.`;
        }

        return _warning;
    }, [message]);

    if (!warning) {
        return null;
    }

    return (
        <Alert severity="warning">
            {warning}
        </Alert>
    );
}
